import { gql } from '@apollo/client';

/**
 * ТЗ 0097 — свои подписи писем: по умолчанию (`mailboxEmail: null`) и по
 * ящикам. Имя операции ≠ поле бэкенда (`myMailSignatures`).
 */
export const MailSignaturesListQuery = gql`
  query MailSignaturesList {
    myMailSignatures {
      id
      mailboxEmail
      html
      source
      importedAt
      updatedAt
    }
  }
`;
